<mat-card class="daxa-card overview-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-content>
        <div class="row">
            <div class="col-md-6 col-xxxl-3">

                <!-- Daily production -->
                <app-daily-production></app-daily-production>

            </div>
            <div class="col-md-6 col-xxxl-3">

                <!-- Total production -->
                <app-total-production></app-total-production>
                
            </div>
            <div class="col-md-6 col-xxxl-3">

                <!-- CO2 savings this year -->
                <app-co2-savings></app-co2-savings>
                
            </div>
            <div class="col-md-6 col-xxxl-3">

                <!-- Total systems-->
                <app-total-systems></app-total-systems>
                
            </div>
        </div>
    </mat-card-content>
</mat-card>